import Client from 'shopify-buy';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: 						false,
        	main: 						undefined,


        	// Crete a private APP (shopifyCtrl) on Shopify to access the token!
        	// https://shopify.dev/custom-storefronts/tools
        	// https://shopify.github.io/js-buy-sdk

			domain: 					'cristina-grajales.myshopify.com',
  			storefrontAccessToken: 		'a251a290359524856f778d667ff99452'

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'shopify_ctrl';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	//console.log( 'shopifyCtrl::Init' );
    	//this.addEvents( true );
    	this.initClient()
	}


	initClient(){
		// Initializing a client to return content in the store's primary language
		const client = Client.buildClient({
		  domain: 					this.options.domain,
		  storefrontAccessToken: 	this.options.storefrontAccessToken
		});	

		this.client = client;

		this.fetchProducts()	
	}

	fetchProducts(){
		let i = 0, p, v, vs, $p;
		// Fetch all products in your shop
		this.client.product.fetchAll().then((products) => {
		  	// Do something with the products
		  	//console.log(products);
		  	i = products.length;
		  	while( i-- ){
		  		p 	= products[i];

		  		// find correspond product by handle id
		  		$p 	= this.$el.find( '#' + p.handle );

		  		if ( p.availableForSale && $p.length > 0 ){

			  		vs 	= p.variants;

			  		// only one variant, keep it simple
			  		if ( vs.length === 1 ){

			  			// one only variant
			  			v = vs[0];

			  			// set price
			  			$p.find( '.price' ).html( '$' + v.price );

			  			// set variant id to retrive later on the lement by it, when the checkout link is ready
			  			$p.attr( 'data-variant-id', v.id );

			  			// crete checkout
						this.client.checkout.create({
						  	lineItems: [
						    	{variantId: v.id, quantity: 1}
						  	]							
						}).then((checkout) => {
						  	// Do something with the newly created checkout
						  	this.onCreateCheckout( checkout );
						});			  			

			  		}
		  		}

		  	}
		});

	}

	onCreateCheckout( checkout ){
		
		if ( checkout.lineItems.length > 0 ){

			let lineItem = checkout.lineItems[0], 
				variant_id = lineItem.variant.id, 

				// retrive lement by data-variant-id
				$p = this.$el.find( '[data-variant-id="' + variant_id + '"]' );

			if ( $p.length > 0 ){
			  	$p.find( '.purchase a' ).attr( 'href', checkout.webUrl );
			  	$p.addClass( 'is-purchasable' );
			}

		}

	}

	//---------------------------------------- EVENTS ---------------------------------------//
	/*
	addEvents( b ){
		if ( b ){
		}
		else{
		}
	}
	*/

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	//console.log( 'shopifyCtrl::destroy' );
    	/*
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    	*/
    }

}